import sanitizeFilter from './sanitizeFilter'

export default sanitizeFilter
